module.exports = __webpack_public_path__ + "img/3G.8842f61d.png";